import { memo } from "react";
import { ChevronRight } from "lucide-react";
import { formatVariantLabel } from "@/lib/variants";
import { computeLine, fmtMoney } from "@/lib/lineMath";

// Telefon: satır kartı — dokununca tam ekran detay düzenleme açılır
export const MobileLineCard = memo(function MobileLineCard({ row, changedSig, onOpen }) {
  const t = computeLine(row);
  const dirty = !!changedSig;
  return (
    <button type="button" onClick={() => onOpen(row.id)} data-testid={`ws-card-${row.id}`}
      className={`w-full text-left px-3.5 py-3 border-b border-slate-800 flex items-center gap-3 active:bg-slate-900
        ${row._deleted ? "opacity-50" : ""} ${dirty ? "border-l-[3px] border-l-amber-400 bg-amber-500/[0.04]" : ""}`}>
      <div className="flex-1 min-w-0">
        <div className="text-[13px] text-slate-100 truncate">{row.product_name}</div>
        <div className="text-[11px] font-mono text-emerald-400 truncate">{formatVariantLabel(row.variant_attributes || {}, row.variant_sku || "—")}</div>
        <div className="mt-1 text-[12px] font-mono text-slate-400 tabular-nums">
          {row.quantity} × {fmtMoney(row.unit_price, row.currency)} · KDV %{row.tax_rate}
          {Number(row.discount_percent) > 0 && ` · İsk %${row.discount_percent}`}
        </div>
      </div>
      <div className="text-right shrink-0">
        <div className="font-mono text-sm font-semibold text-slate-50 tabular-nums">{fmtMoney(t.line_total, row.currency)}</div>
        {dirty && <div className="text-[10px] uppercase tracking-wider text-amber-400">{row._deleted ? "silinecek" : "değişti"}</div>}
      </div>
      <ChevronRight className="w-4 h-4 text-slate-600 shrink-0" />
    </button>
  );
});
